module.exports = __webpack_public_path__ + "static/media/homeIllustration01.31369f6e.svg";